module.exports = __webpack_public_path__ + "static/media/make_order_old.b3cc831e.png";